var messages = {
  perPage: '条/页',
  prevPage: '上一页',
  nextPage: '下一页',
  prevFivePage: '向前5页',
  nextFivePage: '向后5页',
  sum: '共',
  oneUnit: '条',
  goTo: '前往',
  page: '页'
};
export default messages;